const NAMES = {
  bsx: "Basilisk",
  glmr: "Moonbeam [Beta]",
  rmrk: "Kusama",
  ksm: "RMRK2",
  movr: "Moonriver [Beta]",
  snek: "Snek [Rococo]",
  stmn: "Statemine [Beta]",
  dot: "Polkadot",
  stt: "Statemint [Beta]"
};

const toChainProperty = (ss58Format, tokenDecimals, tokenSymbol, blockExplorer) => {
  return {
    ss58Format,
    tokenDecimals,
    tokenSymbol,
    blockExplorer
  };
};
const DEFAULT_CHAIN_PROPERTIES = toChainProperty(
  2,
  12,
  "KSM",
  "https://kusama.subscan.io/"
);
const CHAINS = {
  rmrk: DEFAULT_CHAIN_PROPERTIES,
  ksm: DEFAULT_CHAIN_PROPERTIES,
  bsx: toChainProperty(10041, 12, "BSX", "https://basilisk.subscan.io/"),
  snek: toChainProperty(
    10041,
    12,
    "BSX",
    "https://calamar.play.hydration.cloud/rococo%20basilisk/search?query="
  ),
  movr: toChainProperty(1285, 18, "MOVR", "https://moonriver.subscan.io/"),
  glmr: toChainProperty(1284, 18, "GLMR", "https://moonbeam.subscan.io/"),
  stmn: toChainProperty(2, 12, "KSM", "https://statemine.subscan.io/"),
  dot: toChainProperty(0, 10, "DOT", "https://polkadot.subscan.io/"),
  stt: toChainProperty(0, 10, "DOT", "https://statemint.subscan.io/")
};
const DEFAULT_PREFIX = "ksm";
const chainPrefixes = [
  "bsx",
  "rmrk",
  "snek",
  "movr",
  "glmr",
  "ksm",
  "stmn",
  "dot",
  "stt"
];
const chainPrefixesMap = chainPrefixes.reduce(
  (acc, prefix) => ({
    ...acc,
    [prefix]: prefix
  }),
  {}
);
const chainInfo = {
  bsx: "basilisk",
  rmrk: "kusama",
  snek: "snek",
  movr: "moonriver",
  glmr: "moonbeam",
  ksm: "rmrk",
  stmn: "statemine",
  dot: "polkadot",
  stt: "statemint"
};
const chainNames = {
  bsx: "Basilisk",
  rmrk: "Kusama",
  snek: "Basilisk-testnet",
  movr: "Moonriver",
  glmr: "Moonbeam",
  ksm: "Kusama",
  stmn: "Statemine",
  dot: "Polkadot",
  stt: "Statemint"
};
const chainList = () => {
  return chainPrefixes.map((prefix) => ({
    info: chainInfo[prefix],
    text: NAMES[prefix],
    value: prefix
  }));
};

const KUSAMA_ENDPOINTS = [
  "wss://kusama-rpc.polkadot.io",
  "wss://kusama.public.curie.radiumblock.co/ws",
  "wss://rpc.ibp.network/kusama",
  "wss://rpc.dotters.network/kusama",
  "wss://1rpc.io/ksm",
  "wss://kusama.api.onfinality.io/public-ws",
  "wss://kusama-rpc.dwellir.com"
];
const POLKADOT_ENDPOINTS = [
  "wss://rpc.polkadot.io",
  "wss://polkadot.public.curie.radiumblock.co/ws",
  "wss://rpc.ibp.network/polkadot",
  "wss://rpc.dotters.network/polkadot",
  "wss://1rpc.io/dot",
  "wss://polkadot.api.onfinality.io/public-ws",
  "wss://polkadot-rpc.dwellir.com"
];
const ALTERNATIVE_ENDPOINT_MAP = {
  bsx: ["wss://rpc.basilisk.cloud", "wss://basilisk-rpc.dwellir.com"],
  glmr: ["wss://public-rpc.pinknode.io/moonbeam"],
  rmrk: KUSAMA_ENDPOINTS,
  movr: ["wss://wss.api.moonriver.moonbeam.network"],
  ksm: KUSAMA_ENDPOINTS,
  snek: ["wss://basilisk-rococo-rpc.play.hydration.cloud"],
  stmn: [
    "wss://statemine-rpc.polkadot.io",
    "wss://statemine-rpc.dwellir.com",
    "wss://sys.ibp.network/statemine",
    "wss://sys.dotters.network/statemine",
    "wss://rpc-statemine.luckyfriday.io",
    "wss://statemine.api.onfinality.io/public-ws",
    "wss://statemine.public.curie.radiumblock.co/ws"
  ],
  dot: POLKADOT_ENDPOINTS,
  stt: [
    "wss://statemint-rpc.polkadot.io",
    "wss://statemint-rpc.dwellir.com",
    "wss://statemint-rpc-tn.dwellir.com",
    "wss://sys.ibp.network/statemint",
    "wss://sys.dotters.network/statemint",
    "wss://statemint.api.onfinality.io/public-ws"
  ]
};
const ENDPOINT_MAP = {
  bsx: "wss://rpc.basilisk.cloud",
  glmr: "wss://public-rpc.pinknode.io/moonbeam",
  rmrk: KUSAMA_ENDPOINTS[0],
  movr: "wss://wss.api.moonriver.moonbeam.network",
  ksm: KUSAMA_ENDPOINTS[0],
  snek: "wss://basilisk-rococo-rpc.play.hydration.cloud",
  stmn: "wss://statemine-rpc.polkadot.io",
  dot: POLKADOT_ENDPOINTS[0],
  stt: "wss://statemint-rpc.polkadot.io"
};

const INDEXERS = {
  bsx: "https://squid.subsquid.io/snekk/graphql",
  glmr: "https://squid.subsquid.io/click/v/002/graphql",
  rmrk: "https://squid.subsquid.io/rubick/graphql",
  movr: "https://squid.subsquid.io/antick/v/001-rc0/graphql",
  ksm: "https://squid.subsquid.io/marck/v/v2/graphql",
  snek: "https://squid.subsquid.io/snekk/v/004/graphql",
  stmn: "https://squid.subsquid.io/stick/graphql",
  dot: "https://squid.subsquid.io/rubick/graphql",
  // TODO: change to dot indexer when available
  stt: "https://squid.subsquid.io/speck/v/v1/graphql"
};
const toApolloEndpoint = (httpEndpoint) => ({
  httpEndpoint
});
const reducer = (acc, [key, value]) => {
  acc[key] = toApolloEndpoint(value);
  return acc;
};
const APOLLO_ENDPOINTS = Object.entries(
  INDEXERS
  // eslint-disable-next-line unicorn/no-array-reduce
).reduce(
  (accumulator, element) => reducer(accumulator, element),
  {}
);

const SERVICES = {
  directUpload: "https://direct-upload.w.kodadot.xyz/",
  nftStorage: "https://nft-storage.w.kodadot.xyz/",
  seoCard: "https://og-image-green-seven.vercel.app/",
  replicate: "https://replicate.w.kodadot.xyz/",
  image: "https://image.w.kodadot.xyz/",
  imageBeta: "https://image-beta.w.kodadot.xyz/"
};
const EXPLORERS = {
  rmrk: "https://kusama.subscan.io/account/",
  ksm: "https://kusama.subscan.io/account/",
  bsx: "https://basilisk.subscan.io/account/",
  snek: "https://calamar.play.hydration.cloud/rococo%20basilisk/search?query=",
  movr: "https://moonriver.subscan.io/account/",
  glmr: "https://moonbeam.subscan.io/account/",
  stmn: "https://statemine.subscan.io/account/",
  dot: "https://polkadot.subscan.io/account/",
  stt: "https://statemint.subscan.io/account/"
};
const hasExplorer = (prefix) => {
  return EXPLORERS[prefix] !== void 0;
};
const getExplorer = (prefix, id) => {
  return EXPLORERS[prefix] + id;
};

const mimeTypes = {
  bmp: "image/bmp",
  gif: "image/gif",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
  tiff: "image/tiff",
  webp: "image/webp",
  mp4: "video/mp4",
  ogv: "video/ogg",
  mov: "video/quicktime",
  qt: "video/quicktime",
  webm: "video/webm",
  glb: "model/gltf-binary",
  gltf: "model/gltf+json",
  flac: "audio/flac",
  mp3: "audio/mpeg",
  json: "application/json"
};

export { ALTERNATIVE_ENDPOINT_MAP, APOLLO_ENDPOINTS, CHAINS, DEFAULT_PREFIX, ENDPOINT_MAP, EXPLORERS, INDEXERS, NAMES, SERVICES, chainInfo, chainList, chainNames, chainPrefixes, chainPrefixesMap, getExplorer, hasExplorer, mimeTypes, toApolloEndpoint, toChainProperty };
